import { stringify } from "query-string";
import { DonationFormCategory, FormCategory, FormType, Locales } from "../enums";
export var RoutePrefix;
(function (RoutePrefix) {
    RoutePrefix["Organization"] = "/o";
    RoutePrefix["Donor"] = "/d";
})(RoutePrefix || (RoutePrefix = {}));
export var RoutesParams;
(function (RoutesParams) {
    RoutesParams["RelaunchStripeOnboarding"] = "relaunchStripeOnboarding";
    RoutesParams["StripeOnboardingSucceeded"] = "stripeOnboardingSucceeded";
})(RoutesParams || (RoutesParams = {}));
export const HomePageFreePlatformUrl = {
    [Locales.EN]: "https://www.zeffy.com/home/100-free-for-donors",
    [Locales.FR]: "https://fr.zeffy.com/home/100-free-for-donors",
    [Locales.ES]: "https://www.zeffy.com/home/100-free-for-donors",
};
export class BuiltRoute {
    path;
    searchParams = {};
    constructor(path) {
        this.path = path;
    }
    addSearchParams(searchParams) {
        this.searchParams = { ...this.searchParams, ...searchParams };
        return this;
    }
}
export const buildPathFromTemplate = (template, params) => {
    let output = template;
    for (const [key, value] of Object.entries(params)) {
        if (value) {
            output = output.replace(new RegExp(`\\[(.*?):${key}(.*?)\\]`, "gi"), `$1${value}$2`); // Replace optional parameter
            output = output.replace(new RegExp(`:${key}`, "gi"), value); // Replace required parameter
        }
        else {
            output = output.replace(new RegExp(`(\\[.*?:${key}.*?\\])`, "gi"), ""); // Remove optional parameter
        }
    }
    return new BuiltRoute(output);
};
export const RouteBuilders = {
    homePageFreePlatformUrl: (params) => {
        return new BuiltRoute(HomePageFreePlatformUrl[params.locale]);
    },
    buildCreateNewFormLink: (params) => buildPathFromTemplate(`/:isoLocale${OrganizationRoutes.FormsNew}`, params),
    buildCheckInManagerUrl: (params) => {
        return buildPathFromTemplate(`/:isoLocale/checkin-manager/:token`, params);
    },
    buildCreateNewDonationFormLink: () => {
        return new BuiltRoute(OrganizationRoutes.DonationFormsNew);
    },
    buildCreateNewTicketingFormLink: () => {
        return new BuiltRoute(OrganizationRoutes.TicketingNew);
    },
    buildDashboardHomePageUrl: () => {
        return new BuiltRoute("/o/fundraising/insights");
    },
    buildDonorHomePageUrl: (params) => {
        return buildPathFromTemplate("/:isoLocale/d/payments", params);
    },
    buildPeerToPeerV2CampaignLink: (params) => {
        const { type, ...rest } = params;
        if (type === "general") {
            return RouteBuilders.buildPeerToPeerV2GeneralCampaignLink(rest);
        }
        if (type === "team") {
            return RouteBuilders.buildPeerToPeerV2TeamCampaignLink(rest);
        }
        return RouteBuilders.buildPeerToPeerV2IndividualCampaignLink(rest);
    },
    buildCampaignHubTabLink: (params) => buildPathFromTemplate(`[/:isoLocale]/o/fundraising/campaigns/hub`, params).addSearchParams({
        formId: params.formId,
        tab: params.tab,
    }),
    buildPeerToPeerV2GeneralCampaignLink: (params) => buildPathFromTemplate(`[/:isoLocale]${FrontendRoutes.PeerToPeerPage}:path`, params),
    buildPeerToPeerV2TeamCampaignLink: (params) => buildPathFromTemplate(`[/:isoLocale]${FrontendRoutes.TeamPage}:path`, params),
    buildPeerToPeerV2IndividualCampaignLink: (params) => buildPathFromTemplate(`[/:isoLocale]${FrontendRoutes.FundraisingPage}:path`, params),
    buildDonationFormLink: (params) => buildPathFromTemplate(`[/:isoLocale]${FrontendRoutes.DonationFormPage}:path`, params),
    buildDonationFormEditLink: (params) => buildPathFromTemplate(`[/:isoLocale]/o/donations/forms/edit`, params).addSearchParams({
        donationFormId: params.formId,
    }),
    buildEmbedDonationFormLink: (params) => buildPathFromTemplate(`[/:isoLocale]/embed${FrontendRoutes.DonationFormPage}:path`, params),
    buildTicketingFormLink: (params) => buildPathFromTemplate(`[/:isoLocale]${FrontendRoutes.TicketingPage}:ticketingId`, params),
    buildTicketingFormEditLink: (params) => buildPathFromTemplate(`[/:isoLocale]/o/tickets/forms/edit`, params).addSearchParams({
        ticketingId: params.formId,
    }),
    buildNewsletterFormLink: (params) => buildPathFromTemplate(`[/:isoLocale]${FrontendRoutes.NewsletterFormPage}:path`, params),
    buildEmbedNewsletterFormLink: (params) => buildPathFromTemplate(`[/:isoLocale]/embed${FrontendRoutes.NewsletterFormPage}:path`, params),
    buildContactListsCreateLink: () => new BuiltRoute(OrganizationRoutes.ContactListsCreate),
    buildContactListsLink: (params) => buildPathFromTemplate(`${OrganizationRoutes.ContactLists}[/:contactListId]`, {
        contactListId: params?.contactListId ?? null,
    }),
    buildEmailDeliveryPageLink: (params) => buildPathFromTemplate(`${OrganizationRoutes.Emails}[/:emailDeliveryId]`, {
        emailDeliveryId: params?.emailDeliveryId ?? null,
    }),
    buildPostMailDeliveriesPageLink: () => new BuiltRoute(OrganizationRoutes.PostMail).addSearchParams({ postMailDeliveryId: "" }),
    buildPostMailDeliveryEditorLink: (params) => new BuiltRoute(OrganizationRoutes.PostMailEditor).addSearchParams({
        postMailDeliveryId: params.postMailDeliveryId,
    }),
    buildSettingsPageLink: (params) => new BuiltRoute(OrganizationRoutes.Settings).addSearchParams({
        emailContentId: params.emailContentId,
        onboardCustomDomain: params.onboardCustomDomain,
    }),
    buildDirectRegisterUrl: (params) => new BuiltRoute("/direct-register").addSearchParams({ email: params.email ?? "" }),
};
/**
 * @deprecated Use RouteBuilders instead.
 */
export var FrontendRoutes;
(function (FrontendRoutes) {
    FrontendRoutes["DonationFormPage"] = "/donation-form/";
    FrontendRoutes["PeerToPeerPage"] = "/peer-to-peer/";
    FrontendRoutes["FundraisingPage"] = "/fundraising/";
    FrontendRoutes["Landing"] = "/landing";
    FrontendRoutes["LeaderBoard"] = "/leaderboard/";
    FrontendRoutes["NotFound"] = "/404";
    FrontendRoutes["PeerToPeerSuccess"] = "/peer-to-peer-success";
    FrontendRoutes["TeamPage"] = "/team/";
    FrontendRoutes["ThankYou"] = "/thank-you";
    FrontendRoutes["Thermometer"] = "/thermometer/";
    FrontendRoutes["Ticket"] = "/ticket/";
    FrontendRoutes["TicketingPage"] = "/ticketing/";
    FrontendRoutes["ThreeDSecureSuccess"] = "/three-d-secure-succeed";
    FrontendRoutes["NotFoundBug"] = "/404bug";
    FrontendRoutes["PostFormSubmit"] = "/post-form-submit";
    FrontendRoutes["MembershipCard"] = "/membership/member-info";
    FrontendRoutes["NewsletterFormPage"] = "/newsletter-form/";
    FrontendRoutes["TipRefundPage"] = "/tip-refund";
})(FrontendRoutes || (FrontendRoutes = {}));
/**
 * @deprecated Use RouteBuilders instead.
 */
export var DashboardRoutes;
(function (DashboardRoutes) {
    DashboardRoutes["DonationFormsNew"] = "/donations/forms/new";
    DashboardRoutes["DonationFormsV2New"] = "/donations/formsV2/new";
    DashboardRoutes["DonationFormsEdit"] = "/donations/forms/edit?donationFormId=:id";
    DashboardRoutes["FundraiserFormsEdit"] = "/fundraiser/forms/edit?donationFormId=:id";
    DashboardRoutes["ReceiptGeneration"] = "/receipts/new";
    DashboardRoutes["NotFound"] = "/404";
    DashboardRoutes["Bank"] = "/bank";
    DashboardRoutes["Payouts"] = "/bank/payouts";
    DashboardRoutes["PowerBalancePromo"] = "/bank/power-balance-promo";
    DashboardRoutes["Transactions"] = "/bank/transactions";
    DashboardRoutes["PayoutTransactions"] = "/bank/payouts/transactions?payoutId=:id";
    DashboardRoutes["TicketingNew"] = "/tickets/forms/new";
    DashboardRoutes["TicketingEdit"] = "/tickets/forms/edit?ticketingId=:id";
    DashboardRoutes["CheckinManager"] = "/checkin-manager/:token";
    DashboardRoutes["TicketScanned"] = "/ticket/:id";
    DashboardRoutes["DonorPaymentTable"] = "/payments";
    DashboardRoutes["Contacts"] = "/crm/contacts";
    DashboardRoutes["Emails"] = "/crm/emails";
    DashboardRoutes["SignIn"] = "/login";
    DashboardRoutes["SignOut"] = "/logout";
    DashboardRoutes["SignUp"] = "/register";
    DashboardRoutes["SignUpPostDemo"] = "/register-post-demo";
    DashboardRoutes["ResetPassword"] = "/reset-password";
    DashboardRoutes["CreatePassword"] = "/create-password";
    DashboardRoutes["CreateNewOrganization"] = "/organization/new";
    DashboardRoutes["CreateBankAccount"] = "/bank/account/create";
    DashboardRoutes["MergeUsers"] = "/merge-users";
    DashboardRoutes["VerifyEmail"] = "/verify-email";
    DashboardRoutes["UpdateBankAccount"] = "/bank/account/update";
    DashboardRoutes["Referral"] = "/referral";
    DashboardRoutes["Settings"] = "/settings";
    DashboardRoutes["TapToPayInvitation"] = "/tap-to-pay-invitation";
    DashboardRoutes["DonorCampaigns"] = "/campaigns";
    DashboardRoutes["FormsNew"] = "/forms/new";
    DashboardRoutes["Commands"] = "/commands";
    DashboardRoutes["CostsIndicator"] = "/indicator/costs";
    DashboardRoutes["SwitchOrgAdmin"] = "/admin/switch-org";
    DashboardRoutes["SignInAdmin"] = "/admin/login";
    DashboardRoutes["Metrics"] = "/admin/metrics";
    DashboardRoutes["Import"] = "/import";
    DashboardRoutes["ImportLoading"] = "/import/loading";
    DashboardRoutes["Unsubscribe"] = "/unsubscribe";
    DashboardRoutes["UnsubscribeOrganizationUser"] = "/unsubscribe-organization-user";
    DashboardRoutes["StripeOnboarding"] = "/stripe-onboarding";
    DashboardRoutes["Insights"] = "/fundraising/insights";
    DashboardRoutes["Sandbox"] = "/sandbox";
    DashboardRoutes["Qa"] = "/qa";
    DashboardRoutes["IssuingOnboarding"] = "/issuing-onboarding";
    DashboardRoutes["ExpiredBidderLink"] = "/auction/expired-bidder-link";
    DashboardRoutes["ImportGMailContacts"] = "/sso/import-gmail-contacts";
    DashboardRoutes["ImportMailChimpContacts"] = "/sso/import-mailchimp-contacts";
    DashboardRoutes["GivingTuesdayMap"] = "/giving-tuesday/map";
    DashboardRoutes["FullScreenEmailEditor"] = "/emailing/full-screen-email-editor";
    DashboardRoutes["TicketingV2New"] = "/tickets/formsV2/new";
    DashboardRoutes["Accounts"] = "/bank/accounts";
    DashboardRoutes["Campaigns"] = "/fundraising/campaigns";
    DashboardRoutes["CampaignHub"] = "/fundraising/campaigns/hub";
    DashboardRoutes["Support"] = "/admin/support";
    DashboardRoutes["Payments"] = "/fundraising/payments";
    DashboardRoutes["Receipts"] = "/fundraising/receipts";
    DashboardRoutes["NewsletterForms"] = "/crm/forms";
    DashboardRoutes["NewsletterFormsNew"] = "/crm/forms/new";
    DashboardRoutes["NewsletterFormsEdit"] = "/crm/forms/edit?newsletterFormId=:id";
    DashboardRoutes["PostMail"] = "/crm/post-mails";
    DashboardRoutes["PostMailEditor"] = "/crm/post-mails/editor";
    DashboardRoutes["ContactLists"] = "/crm/lists";
    DashboardRoutes["ContactListsCreate"] = "/crm/lists/create";
    DashboardRoutes["SwiftAidOnboarding"] = "/swift-aid-onboarding";
})(DashboardRoutes || (DashboardRoutes = {}));
export var MobileRoutes;
(function (MobileRoutes) {
    MobileRoutes["ResetPassword"] = "ResetPassword";
    MobileRoutes["PaymentItem"] = "PaymentItem";
})(MobileRoutes || (MobileRoutes = {}));
export var FormQueryParams;
(function (FormQueryParams) {
    FormQueryParams["Modal"] = "modal";
})(FormQueryParams || (FormQueryParams = {}));
export var PeerToPeerQueryParams;
(function (PeerToPeerQueryParams) {
    PeerToPeerQueryParams["OpenFundraiser"] = "openFundraiser";
    PeerToPeerQueryParams["OpenTeamCreation"] = "openTeamCreation";
    PeerToPeerQueryParams["OpenTeamJoin"] = "openTeamJoin";
    PeerToPeerQueryParams["DefaultFundraiserTarget"] = "target";
})(PeerToPeerQueryParams || (PeerToPeerQueryParams = {}));
const getPathWithLocale = (path, isoLocale) => {
    return isoLocale ? `/${isoLocale}${path}` : path;
};
export const getFormLink = (donationForm, isoLocale) => {
    if (donationForm.category === DonationFormCategory.PeerToPeerCampaign) {
        return RouteBuilders.buildPeerToPeerV2CampaignLink({
            type: donationForm.isPrimaryCampaign ? "general" : donationForm.isPrimaryTeam ? "team" : "individual",
            path: donationForm.path,
            isoLocale,
        }).path;
    }
    return RouteBuilders.buildDonationFormLink({
        path: donationForm.path,
        isoLocale,
    }).path;
};
export const getDonationOrTicketingFormLink = ({ form, isoLocale }) => {
    if (form.formType === FormType.Ticketing) {
        return getTicketingLink(form.path, isoLocale);
    }
    return getFormLink({
        ...form,
        category: form.formCategory === FormCategory.DonationForm
            ? DonationFormCategory.DonationForm
            : DonationFormCategory.PeerToPeerCampaign,
    }, isoLocale);
};
export const getDonationOrTicketingEmbedLink = ({ form, isoLocale }) => {
    if (form.formType === FormType.Ticketing) {
        return getEmbedTicketingLink(form.path, isoLocale);
    }
    return getEmbedFormLink({
        ...form,
        category: form.formCategory === FormCategory.DonationForm
            ? DonationFormCategory.DonationForm
            : DonationFormCategory.PeerToPeerCampaign,
    }, isoLocale);
};
export const getEmbedFormLink = (donationForm, isoLocale) => {
    return RouteBuilders.buildEmbedDonationFormLink({
        isoLocale,
        path: donationForm.path,
    }).path;
};
export const getEmbedThermometerLink = (path, isoLocale) => {
    return getPathWithLocale(`/embed${FrontendRoutes.Thermometer}${path}`, isoLocale);
};
export const getEmbedLeaderboardLink = (path, isoLocale) => {
    return getPathWithLocale(`/embed${FrontendRoutes.LeaderBoard}${path}`, isoLocale);
};
export const getTicketingLink = (path, isoLocale) => {
    return getPathWithLocale(`${FrontendRoutes.TicketingPage}${path}`, isoLocale);
};
export const getEmbedTicketingLink = (path, isoLocale, params) => {
    const queryParams = params ? `?${stringify(params || {})}` : "";
    return getPathWithLocale(`/embed${FrontendRoutes.TicketingPage}${path}${queryParams}`, isoLocale);
};
export const getTeamLink = (path, isoLocale) => {
    if (!path) {
        return null;
    }
    return `/${isoLocale}${FrontendRoutes.TeamPage}${path}`;
};
export const getIndividualFundraisingLink = (path, isoLocale) => {
    if (!path) {
        return null;
    }
    return RouteBuilders.buildDonationFormLink({
        isoLocale,
        path,
    }).path;
};
export const SHOW_SUCCESS_BANK_MODALE_QUERY_PARAM = "showSuccessBankModal";
export const IS_SUPER_ADMIN_QUERY_PARAM = "isSuperAdmin";
export var CampaignPaymentTab;
(function (CampaignPaymentTab) {
    CampaignPaymentTab["Overview"] = "overview";
    CampaignPaymentTab["Payment"] = "payment";
    CampaignPaymentTab["Guest"] = "guest";
    CampaignPaymentTab["Communication"] = "communication";
    CampaignPaymentTab["Product"] = "product";
    CampaignPaymentTab["ProductBid"] = "product-bid";
    CampaignPaymentTab["Todos"] = "todos";
})(CampaignPaymentTab || (CampaignPaymentTab = {}));
/** @deprecated Use RouteBuilders instead */
export const OrganizationRoutes = Object.fromEntries(Object.entries(DashboardRoutes).map(([key, value]) => [key, RoutePrefix.Organization + value]));
/** @deprecated Use RouteBuilders instead */
export const DonorRoutes = Object.fromEntries(Object.entries(DashboardRoutes).map(([key, value]) => [key, RoutePrefix.Donor + value]));
/** @deprecated Use RouteBuilders instead */
export const PublicRoutes = Object.fromEntries(Object.entries(DashboardRoutes).map(([key, value]) => [key, value]));
